import React from 'react';
import playButtonGif from "../../../assets/gif/guidelines/play.gif";
import '../../../assets/css/pages/guidelines/sections/youtubeModal.scss';

const YoutubeModal = () => {
    return (
        <>
            <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="video-play-btn"
                    data-toggle="modal"
                    data-target="#youtubeVideoShowing"
                >
                    <img width="270" src={playButtonGif} alt=""/>
                </button>
            </div>
            <div
                className="modal fade"
                id="youtubeVideoShowing"
                tabIndex="-1"
                aria-labelledby="youtubeVideoShowingLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content bg-transparent">
                        <div className="modal-body p-0">
                            <div className='text-right'>
                                <button type="button" className="close" data-dismiss="modal"
                                        aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <iframe
                                width="100%"
                                height="550"
                                src="https://www.youtube.com/embed/0hlmYFcQb4Q"
                                title="CBMS Overview"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default YoutubeModal;
